import Phaser from "phaser";

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: "BootScene" });
  }

  preload() {
    // Load any assets needed for the loading screen
    this.load.image("logo", "assets/logo.png");
  }

  create() {
    this.scene.start("PreloadScene");
  }
}
